import styled, {css} from "styled-components"

import padding from "@irati/ui/src/global/padding"
import Expander from "@irati/ui/src/Expander"
import {Card, Hr} from "@irati/ui/src/Layout"

interface AccordionItemProps {
  isInner?: boolean
}

export const SpacedCard = styled(Card)<AccordionItemProps>`
  margin-bottom: ${padding.small};

  ${({theme, isInner}) => isInner && css`
    background-color: ${theme.colors.greys.lightest};
    box-shadow: ${theme.shadows.low};
  `}
`

export const AccordionExpander = styled(Expander)<AccordionItemProps>`
  padding: ${({isInner}) => (isInner ? padding.small : padding.base)};
`

export const AccordionContent = styled.div<AccordionItemProps>`
  padding: 0 ${padding.base} ${padding.base} ${padding.base};

  ${({isInner}) => isInner && `padding: 0 ${padding.small} ${padding.small} ${padding.small};`}
`

export const FlushTopHr = styled(Hr)`
  margin-top: 0;
`
